import { useCallback, useState } from "react";

import useUserComboboxQuery from "@components/user-combobox/use-user-combobox-query";
import UserCombobox from "@components/user-combobox/user-combobox";
import { UserComboboxOption } from "@components/user-combobox/user-combobox-list";

const TeamMemberCombobox = ({
  excludeUserIds,
  onSelect,
  closeOnSelect,
}: {
  excludeUserIds: number[];
  onSelect: (option: UserComboboxOption | null) => void;
  closeOnSelect?: boolean;
}) => {
  const [canLoadData, setCanLoadData] = useState(false);
  const { loading, options, query, setQuery } = useUserComboboxQuery({
    queryOptions: {
      skip: !canLoadData,
    },
    excludeUserIds: excludeUserIds,
  });

  const handlePreloadData = () => {
    setCanLoadData(true);
  };

  const handleClearValue = () => {
    onSelect(null);
  };

  const handleSelect = useCallback(
    (option: UserComboboxOption | null) => {
      onSelect(option);
      setQuery("");
    },
    [onSelect, setQuery],
  );

  return (
    <div className="flex-1 flex gap-2 items-center">
      <div className="flex-1" onMouseEnter={handlePreloadData}>
        <UserCombobox
          searchPlaceholder="Pick a member"
          placeholder="Pick a member"
          aria-label="Manager combobox"
          loading={loading}
          query={query}
          value={null}
          options={options}
          onChangeValue={handleSelect}
          onChangeQuery={setQuery}
          onClickButton={handlePreloadData}
          onClearValue={handleClearValue}
          closeOnSelect={closeOnSelect}
        />
      </div>
    </div>
  );
};

export default TeamMemberCombobox;
